

exports.__esModule = true;
exports.$RouteToCompleteRoute = void 0;
var _squid = require("squid");
require("./directive");
var $RouteToCompleteRoute = exports.$RouteToCompleteRoute = _squid.$ComponentRoute.extend('$RouteToCompleteRoute', {
  name: 'routeToComplete',
  directive: 'xo-route-to-complete',
  titleContent: 'genericError.pleaseTryAgain',
  query: ['url', 'urlType'],
  trackingData: {
    fptiState: 'route-to-complete',
    buzname: {
      'fullpage': {
        'pagename': '%::route-to-complete',
        'pagename2': '%::route-to-complete:member:hermes:',
        'version': 'member:%:'
      }
    }
  },
  children: []
});
angular.value("$RouteToCompleteRoute", $RouteToCompleteRoute);
_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-page-components/src/route-to-complete/route.js
// module id = ../node_modules/xo-page-components/src/route-to-complete/route.js
// module chunks = 0